import type { Instance } from "mobx-state-tree";
import { RootStore } from "./RootStore";
import type { RootStoreSnapshotIn } from "./types";
import { connectDevTools } from "./devtools";
import {
  connectBuildingDataWidgetPersistence,
  loadBuildingDataWidgetSnapshot,
} from "./ui/buildingDataWidgetStore";
import {
  connectBuildingViewModePersistence,
  loadBuildingViewModeSnapshot,
} from "./ui/buildingViewModeStore";

export function createStore(initialState?: RootStoreSnapshotIn): Instance<typeof RootStore> {
  const mergedInitial: RootStoreSnapshotIn = {
    ...(initialState ?? {}),
    buildingDataWidgetStore: {
      ...loadBuildingDataWidgetSnapshot(),
      ...(initialState?.buildingDataWidgetStore ?? {}),
    },
    buildingViewModeStore: {
      ...loadBuildingViewModeSnapshot(),
      ...(initialState?.buildingViewModeStore ?? {}),
    },
  };
  const store = RootStore.create(mergedInitial);
  connectDevTools(store, "Link It Up MST Store");
  connectBuildingDataWidgetPersistence(store.buildingDataWidgetStore);
  // buildingScopeStore is deliberately NOT persisted — the selected project is
  // per-session so Projects view always forces a fresh pick.
  connectBuildingViewModePersistence(store.buildingViewModeStore);
  return store;
}

export function createTestStore(initialState?: RootStoreSnapshotIn): Instance<typeof RootStore> {
  return RootStore.create(initialState ?? {});
}
